$(document).on("turbolinks:load", function () {
  licensesForAddons()

  $(".product_category_addons").on("change", function () {
    licensesForAddons()
  })
})

function licensesForAddons() {
  var $isAddonChecked = $(".product_category_addons").is(":checked")
  var $licenses = $('input[name="product[info_attributes][license]"]')

  $licenses.each(function () {
    var $this = $(this)
    var shouldDisable =
      $isAddonChecked && !["mit", "gpl"].includes($(this).val())

    if (shouldDisable) {
      $this.prop("checked", false)
    }

    $this.prop("disabled", shouldDisable)
  })
}
